import { useState } from 'react';
import { Button } from '@mui/material';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { useTranslation } from 'react-i18next';
import { CLICKDUMMY_EXPORT_ENABLED } from '../../export/constants';
import { useCanExportProject } from '../../export/permission';
import { ExportDialog } from './ExportDialog';

interface Props {
  projectId: string;
  projectName: string;
}

function ExportMenuButtonInner({ projectId, projectName }: Props) {
  const { t } = useTranslation('projects');
  const allowed = useCanExportProject(projectId);
  const [open, setOpen] = useState(false);
  if (!allowed) return null;
  return (
    <>
      <Button variant="outlined" startIcon={<FileDownloadIcon />} onClick={() => setOpen(true)}>
        {t('export.button', 'Als Clickdummy exportieren')}
      </Button>
      {open && <ExportDialog open onClose={() => setOpen(false)} projectId={projectId} projectName={projectName} />}
    </>
  );
}

/** Wrapper ohne Hooks: bei abgeschaltetem Export wird nichts gerendert und nichts geladen. */
export function ExportMenuButton(props: Props) {
  if (!CLICKDUMMY_EXPORT_ENABLED) return null;
  return <ExportMenuButtonInner {...props} />;
}

export default ExportMenuButton;
